/**
 * Open a URL in the system browser on native, or a new tab on web.
 * Avoids URLs opening inside the Capacitor WebView.
 */
export async function openExternalUrl(url) {
  const isNative = typeof window !== 'undefined' &&
    window.Capacitor?.isNativePlatform?.()

  if (isNative) {
    const { Browser } = await import('@capacitor/browser')
    await Browser.open({ url })
  } else {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}
